// routes/CompanyRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Companies from '../components/Companies/Companies';
import AddCompany from '../components/Companies/AddCompany';

export const companyRoutes = (
  <Route path="/companies" element={<MainLayout />}>
    <Route index element={<Companies />} />
    <Route path="add_company" element={<AddCompany />} />
    <Route path="edit_company/:companyId" element={<AddCompany />} />
  </Route>
);
